import { css, type Theme } from "@emotion/react";

export const activeButton = (theme: Theme) => css`
  border-color: ${theme.primary.borderBase};
  border-width: 1.25px;
  border-style: solid;
`;
